import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';

extendZodWithOpenApi(z);

export const ListMetaApi = z
  .object({
    total_items: z.number().int().min(0).openapi({
      description: 'Total number of items across all pages (for pagination)'
    })
  })
  .meta({
    id: 'ListMetaApi',
    description: 'Metadata for paginated list responses'
  });

export type ListMetaApi = z.infer<typeof ListMetaApi>;
